export function accordion() {
    let accordions = document.querySelectorAll('.accordion__list')

    if (!accordions) {
        return;
    }

    accordions.forEach((accordion) => {
        let items = accordion.querySelectorAll('.accordion__list__item'),
            content = accordion.querySelectorAll('.accordion__list__item .accordion__list__item__content');

        for (let i = 0; i < items.length; i++) {
            let currentItem = items[i],
                currentContent = content[i];

            currentItem.addEventListener('click', () => {
              if(parseInt(currentContent.style.height) != currentContent.scrollHeight){
                  currentContent.style.height = currentContent.scrollHeight + 'px';
                  currentItem.classList.toggle('open')
                  currentItem.querySelector('button').setAttribute('aria-expanded', 'true')
              }else{
                  currentContent.style.height = 0
                  currentItem.classList.toggle('open')
                  currentItem.querySelector('button').setAttribute('aria-expanded', 'false')

              }
            })
        }
    })
}